import { render, staticRenderFns } from "./search-form-kollegenauslieferung.html?vue&type=template&id=ee8d5464&scoped=true&"
import script from "./search-form-kollegenauslieferung.ts?vue&type=script&lang=ts&"
export * from "./search-form-kollegenauslieferung.ts?vue&type=script&lang=ts&"
import style0 from "./search-form-kollegenauslieferung.scss?vue&type=style&index=0&id=ee8d5464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8d5464",
  null
  
)

/* custom blocks */
import block0 from "./search-form-kollegenauslieferung.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fkollegenauslieferung%2Fsearch-form-kollegenauslieferung%2Fsearch-form-kollegenauslieferung.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports